// Kendi paketini oluştur: paket büyüklüğü + beden + renk seçimi, tek tıkla /cart/add.js
if (!customElements.get('sg-pack-builder')) {
  customElements.define(
    'sg-pack-builder',
    class SgPackBuilder extends HTMLElement {
      connectedCallback() {
        const dataEl = this.querySelector('[data-pack-data]');
        if (!dataEl) return;
        try {
          this.data = JSON.parse(dataEl.textContent);
        } catch (error) {
          console.error('sg-pack-builder: data could not be parsed', error);
          return;
        }
        this.products = this.data.products.map((product) => this.prepareProduct(product));
        // Paket fiyatı hesabının tabanı: ilk ürünün en uygun stoktaki varyantı (kuruş)
        const basePrices = this.products[0]
          ? this.products[0].variants.filter((variant) => variant.available).map((variant) => variant.price)
          : [];
        this.basePrice = basePrices.length ? Math.min(...basePrices) : 0;
        this.strings = this.data.strings;
        this.pairsPerUnit = parseInt(this.dataset.pairsPerUnit, 10) || 1;
        this.giftThreshold = parseInt(this.dataset.giftThreshold, 10) || 0;
        this.giftProduct = parseInt(this.dataset.giftProduct, 10) || null;
        this.giftVariant = parseInt(this.dataset.giftVariant, 10) || null;
        // 'paket:tutar' çiftleri, ör. '3:150, 5:450' -> en büyük uygun eşik uygulanır
        this.discounts = (this.dataset.discounts || '')
          .split(',')
          .map((pair) => pair.split(':').map((value) => parseFloat(value)))
          .filter(([units, amount]) => units > 0 && amount > 0)
          .sort((a, b) => b[0] - a[0]);
        // 'paket:toplam TL' çiftleri, ör. '2:900, 6:1800' -> doluysa indirim yerine bu toplamlar kullanılır
        this.prices = (this.dataset.prices || '')
          .split(',')
          .map((pair) => pair.split(':').map((value) => parseFloat(value)))
          .filter(([units, total]) => units > 0 && total > 0)
          .sort((a, b) => b[0] - a[0]);
        // Sitedeki yazılarla aynı biçim: "1.200 TL" (₺ işareti yerine sonda TL)
        const currency = this.dataset.currency || 'TRY';
        const number = new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
        const fallback = new Intl.NumberFormat('tr-TR', { style: 'currency', currency, maximumFractionDigits: 2 });
        this.formatter = {
          format: (value) => (currency === 'TRY' ? `${number.format(value)} TL` : fallback.format(value)),
        };

        this.els = {
          slots: this.querySelector('[data-slots]'),
          swatches: this.querySelector('[data-swatches]'),
          fits: this.querySelector('[data-fits]'),
          total: this.querySelector('[data-total]'),
          compare: this.querySelector('[data-compare]'),
          add: this.querySelector('[data-add]'),
          status: this.querySelector('[data-status]'),
          gift: this.querySelector('[data-gift]'),
          box: this.querySelector('[data-box]'),
          bar: this.querySelector('[data-bar]'),
          barThumbs: this.querySelector('[data-bar-thumbs]'),
          barCount: this.querySelector('[data-bar-count]'),
          barTotal: this.querySelector('[data-bar-total]'),
          barAdd: this.querySelector('[data-bar-add]'),
          barToast: this.querySelector('[data-bar-toast]'),
        };

        this.activeProduct = 0;
        this.fit = this.allFits()[0] || null;
        this.slots = [];
        const wanted = new URLSearchParams(window.location.search).get('paket');
        const wantedInput = wanted && this.querySelector(`input[name^="sg-size-"][data-pairs="${parseInt(wanted, 10)}"]`);
        if (wantedInput) wantedInput.checked = true;
        this.setUnits(this.checkedSize(), this.checkedFree());

        this.querySelectorAll(`input[name^="sg-size-"]`).forEach((input) =>
          input.addEventListener('change', () => this.setUnits(this.checkedSize(), this.checkedFree()))
        );
        this.querySelectorAll('[data-tab]').forEach((tab) =>
          tab.addEventListener('click', () => this.setTab(parseInt(tab.dataset.tab, 10)))
        );
        this.querySelector('[data-random]').addEventListener('click', () => this.randomFill());
        this.els.add.addEventListener('click', () => this.addToCart());
        if (this.els.bar) this.setupBar();

        this.renderFits();
        this.renderSwatches();
        this.renderSizePrices();
      }

      // Paket kartlarında toplam ve çift başı fiyat: ilk ürünün en uygun varyantı üzerinden, paket indirimi düşülmüş
      renderSizePrices() {
        const first = this.products[0];
        if (!first) return;
        const prices = first.variants.filter((variant) => variant.available).map((variant) => variant.price);
        if (!prices.length) return;
        const base = Math.min(...prices);
        this.querySelectorAll('input[name^="sg-size-"]').forEach((input) => {
          const paid = parseInt(input.value, 10) || 1;
          const free = parseInt(input.dataset.free, 10) || 0;
          const units = paid + free;
          // Çift başı fiyat hediye çiftler dahil: 30+6 çift 1.800 TL -> 50 TL/çift
          const pairs = (parseInt(input.dataset.pairs, 10) || paid * this.pairsPerUnit) + free * this.pairsPerUnit;
          const total = Math.max(base * units - this.discountFor(units), 0);
          const card = input.closest('.sg-pack__size');
          const price = card && card.querySelector('[data-size-price]');
          const hint = card && card.querySelector('[data-size-hint]');
          if (price) price.textContent = this.formatter.format(total / 100);
          if (hint) hint.textContent = `${this.formatter.format(total / pairs / 100)}/${this.strings.pairWord}`;
        });
      }

      // Mobil alt çubuk: seçim alanı ekrandayken ama kutu görünmüyorken çıkar
      setupBar() {
        this.els.barAdd.addEventListener('click', () => this.addToCart());
        this.querySelector('[data-bar-jump]').addEventListener('click', () =>
          this.els.box.scrollIntoView({ behavior: 'smooth', block: 'center' })
        );
        if (!('IntersectionObserver' in window)) return;
        const controls = this.querySelector('.sg-pack__controls');
        this.inView = { controls: false, box: false };
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            this.inView[entry.target === this.els.box ? 'box' : 'controls'] = entry.isIntersecting;
          });
          const show = this.inView.controls && !this.inView.box;
          this.els.bar.classList.toggle('is-visible', show);
          this.els.bar.setAttribute('aria-hidden', String(!show));
          this.els.bar.querySelectorAll('button').forEach((button) => (button.tabIndex = show ? 0 : -1));
        });
        observer.observe(controls);
        observer.observe(this.els.box);
      }

      imageFor(product, color) {
        if (!product) return null;
        const images = product.images || {};
        const key = String(color || '');
        return images[key.toLocaleLowerCase('tr')] || images[key.toLowerCase()] || product.cover || null;
      }

      prepareProduct(product) {
        const colorIndex = product.colorIndex;
        const optionCount = product.variants[0] ? product.variants[0].options.length : 1;
        let fitIndex = -1;
        for (let i = 0; i < optionCount; i++) {
          if (i !== colorIndex) {
            fitIndex = i;
            break;
          }
        }
        const colors = [];
        const fits = [];
        product.variants.forEach((variant) => {
          const color = variant.options[colorIndex];
          if (!colors.includes(color)) colors.push(color);
          if (fitIndex > -1) {
            const fit = variant.options[fitIndex];
            if (!fits.includes(fit)) fits.push(fit);
          }
        });
        return { ...product, fitIndex, colors, fits };
      }

      allFits() {
        const fits = [];
        this.products.forEach((product) => product.fits.forEach((fit) => !fits.includes(fit) && fits.push(fit)));
        return fits;
      }

      findVariant(product, color) {
        return product.variants.find(
          (variant) =>
            variant.options[product.colorIndex] === color &&
            (product.fitIndex === -1 || variant.options[product.fitIndex] === this.fit)
        );
      }

      checkedSize() {
        const checked = this.querySelector('input[name^="sg-size-"]:checked');
        return checked ? parseInt(checked.value, 10) || 1 : 1;
      }

      checkedFree() {
        const checked = this.querySelector('input[name^="sg-size-"]:checked');
        return checked ? parseInt(checked.dataset.free, 10) || 0 : 0;
      }

      // units: ücretli paketler, free: kutunun sonuna eklenen hediye paketler
      setUnits(units, free = 0) {
        this.units = units;
        this.free = free;
        const total = units + free;
        this.slots = this.slots.slice(0, total);
        while (this.slots.length < total) this.slots.push(null);
        this.renderSlots();
      }

      isGiftSlot(index) {
        return index >= this.units;
      }

      setTab(index) {
        this.activeProduct = index;
        this.querySelectorAll('[data-tab]').forEach((tab) =>
          tab.setAttribute('aria-selected', String(parseInt(tab.dataset.tab, 10) === index))
        );
        this.renderSwatches();
      }

      setFit(fit) {
        this.fit = fit;
        // Seçili paketleri yeni bedene taşı; o bedende olmayanları boşalt
        this.slots = this.slots.map((slot) => {
          if (!slot) return null;
          const product = this.products[slot.product];
          const variant = this.findVariant(product, slot.color);
          return variant && variant.available ? { ...slot, variant } : null;
        });
        this.renderFits();
        this.renderSwatches();
        this.renderSlots();
      }

      pick(productIndex, color) {
        const product = this.products[productIndex];
        const variant = this.findVariant(product, color);
        if (!variant || !variant.available) return;
        let index = this.slots.findIndex((slot) => slot === null);
        if (index === -1) index = this.slots.length - 1;
        this.slots[index] = { product: productIndex, color, variant };
        this.renderSlots(index);
        this.renderSwatches();
        this.toast(this.strings.picked.replace('[item]', `${product.title} · ${color}`));
        // Ürün sayfasında galeri seçilen renge geçsin (sg-variant-media dinler)
        document.dispatchEvent(new CustomEvent('sg:pack-pick', { detail: { productId: product.id, color } }));
      }

      toast(message) {
        if (!this.els.barToast) return;
        this.els.barToast.textContent = message;
        this.els.bar.classList.remove('is-toasting');
        void this.els.bar.offsetWidth;
        this.els.bar.classList.add('is-toasting');
        window.clearTimeout(this.toastTimer);
        this.toastTimer = window.setTimeout(() => this.els.bar.classList.remove('is-toasting'), 1600);
      }

      removeSlot(index) {
        this.slots[index] = null;
        this.renderSlots();
        this.renderSwatches();
      }

      randomFill() {
        const options = [];
        this.products.forEach((product, productIndex) =>
          product.colors.forEach((color) => {
            const variant = this.findVariant(product, color);
            if (variant && variant.available) options.push({ product: productIndex, color, variant });
          })
        );
        if (!options.length) return;
        const filled = [];
        this.slots = this.slots.map((slot, index) => {
          if (slot) return slot;
          filled.push(index);
          return options[Math.floor(Math.random() * options.length)];
        });
        this.renderSlots(filled);
        this.renderSwatches();
      }

      hexFor(color) {
        const hex = color ? this.data.colors[String(color).toLowerCase()] : null;
        return hex && /^#[0-9a-f]{3,8}$/i.test(hex) ? hex : null;
      }

      colorStyle(product, color) {
        const hex = this.hexFor(color);
        if (hex) return `--sg-swatch: ${hex}`;
        const variant = product.variants.find((v) => v.options[product.colorIndex] === color && v.image);
        return variant ? `--sg-swatch-image: url("${variant.image}")` : '';
      }

      thumbHTML(product, color) {
        const image = this.imageFor(product, color);
        if (!image) return this.sockHTML(product, color);
        const hex = this.hexFor(color);
        return `<span class="sg-pack__thumb" aria-hidden="true"><img src="${image}" alt="" loading="lazy" width="96" height="96">${
          hex ? `<span class="sg-pack__thumb-dot" style="--sg-swatch: ${hex}"></span>` : ''
        }</span>`;
      }

      sockHTML(product, color) {
        const hex = this.hexFor(color);
        if (product && !hex) {
          return `<span class="sg-pack__sock sg-pack__sock--image" style='${this.colorStyle(product, color)}' aria-hidden="true"></span>`;
        }
        return `<svg class="sg-pack__sock${color ? '' : ' sg-pack__sock--ghost'}" viewBox="0 0 32 40" aria-hidden="true" focusable="false"><path d="M9 1.5h12v20c0 2 1 3.4 3 4.4l2.4 1.4c4 2.6 3 9.4-2.6 10.6-3 .7-5.8-.1-8.6-2l-7.6-5.6C5.7 28.8 4.5 26.8 4.5 24V1.5z" fill="${
          hex || 'none'
        }" stroke="currentColor" stroke-width="2" stroke-linejoin="round"${color ? '' : ' stroke-dasharray="3 3"'}/><path d="M9 7h12" stroke="currentColor" stroke-width="2"/></svg>`;
      }

      renderFits() {
        const fits = this.allFits();
        const step = this.querySelector('[data-size-step]');
        if (!fits.length) {
          step.hidden = true;
          return;
        }
        this.els.fits.innerHTML = '';
        fits.forEach((fit) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'sg-pack__fit';
          button.textContent = String(fit).replace(/\s*\([^)]*\)\s*$/, '') || fit;
          button.setAttribute('aria-pressed', String(fit === this.fit));
          button.addEventListener('click', () => this.setFit(fit));
          this.els.fits.appendChild(button);
        });
      }

      renderSwatches() {
        const product = this.products[this.activeProduct];
        if (!product) return;
        this.els.swatches.innerHTML = '';
        product.colors.forEach((color) => {
          const variant = this.findVariant(product, color);
          const available = variant && variant.available;
          const count = this.slots.filter((slot) => slot && slot.product === this.activeProduct && slot.color === color).length;
          const image = this.imageFor(product, color);
          // Bu bedende tükendiyse diğer bedende var mı? Kartın altında söyleriz
          const otherFit =
            !available && product.variants.some((other) => other.available && other.options[product.colorIndex] === color);
          const button = document.createElement('button');
          button.type = 'button';
          button.className = `sg-pack__swatch${image ? ' sg-pack__swatch--photo' : ''}${count ? ' is-picked' : ''}${
            available ? '' : ' is-soldout'
          }`;
          button.disabled = !available;
          button.setAttribute(
            'aria-label',
            `${product.title}, ${color}${available ? '' : ` (${this.strings.soldOut})`}${count ? ` (${count})` : ''}`
          );
          const soldBadge = available ? '' : `<span class="sg-pack__swatch-soldout" aria-hidden="true"></span>`;
          const visual = image
            ? `<span class="sg-pack__swatch-photo"><img src="${image}" alt="" width="120" height="160">${soldBadge}<span class="sg-pack__swatch-dot sg-pack__swatch-dot--mini" style='${this.colorStyle(
                product,
                color
              )}'></span></span>`
            : `<span class="sg-pack__swatch-dot" style='${this.colorStyle(product, color)}'></span>${soldBadge}`;
          button.innerHTML = `${visual}<span class="sg-pack__swatch-name"></span>${
            available ? '' : '<span class="sg-pack__swatch-note"></span>'
          }${count ? `<span class="sg-pack__swatch-count" aria-hidden="true">×${count}</span>` : ''}${
            available ? '<span class="sg-pack__swatch-plus" aria-hidden="true">+</span>' : ''
          }`;
          button.querySelector('.sg-pack__swatch-name').textContent = color;
          if (!available) {
            button.querySelector('.sg-pack__swatch-soldout').textContent = this.strings.soldOut || 'Tükendi';
            button.querySelector('.sg-pack__swatch-note').textContent = otherFit
              ? this.strings.otherFitNote || ''
              : this.strings.soldOutNote || '';
          }
          button.addEventListener('click', () => this.pick(this.activeProduct, color));
          this.els.swatches.appendChild(button);
        });
      }

      renderSlots(animate = []) {
        const animated = Array.isArray(animate) ? animate : [animate];
        this.els.slots.innerHTML = '';
        this.slots.forEach((slot, index) => {
          const li = document.createElement('li');
          li.className = `sg-pack__slot${this.isGiftSlot(index) ? ' is-gift' : ''}`;
          if (slot) {
            const product = this.products[slot.product];
            li.classList.add('is-filled');
            if (animated.includes(index)) li.classList.add('is-new');
            li.innerHTML = `<button type="button" class="sg-pack__slot-btn">${this.thumbHTML(
              product,
              slot.color
            )}<span class="sg-pack__slot-text"><span class="sg-pack__slot-name"></span><span class="sg-pack__slot-meta"></span></span><span class="sg-pack__slot-x" aria-hidden="true">×</span></button>`;
            li.querySelector('.sg-pack__slot-name').textContent = `${product.title} · ${slot.color}`;
            const fit =
              product.fitIndex > -1 ? String(slot.variant.options[product.fitIndex]).replace(/\s*\([^)]*\)\s*$/, '') : '';
            li.querySelector('.sg-pack__slot-meta').textContent = [`${this.pairsPerUnit} ${this.strings.pairWord}`, fit]
              .filter(Boolean)
              .join(' · ');
            if (this.isGiftSlot(index)) {
              const tag = document.createElement('span');
              tag.className = 'sg-pack__slot-gift';
              tag.textContent = `🎁 ${this.strings.giftTag}`;
              li.querySelector('.sg-pack__slot-text').prepend(tag);
            }
            const button = li.querySelector('button');
            button.setAttribute('aria-label', `${this.strings.remove}: ${product.title}, ${slot.color}`);
            button.addEventListener('click', () => this.removeSlot(index));
          } else {
            li.innerHTML = `<span class="sg-pack__slot-empty">${this.sockHTML(null, null)}<span></span></span>`;
            li.querySelector('.sg-pack__slot-empty span:last-child').textContent = this.isGiftSlot(index)
              ? `🎁 #${index + 1} · ${this.strings.giftSlot}`
              : `#${index + 1} · ${this.strings.slotEmpty}`;
          }
          this.els.slots.appendChild(li);
        });
        this.updateSummary();
      }

      updateSummary(resetStatus = true) {
        const filled = this.slots.filter(Boolean);
        const missing = this.slots.length - filled.length;
        // Kutu yarım doluyken de seçilen paketin fiyatı görünür (boş sıralar taban fiyattan sayılır);
        // aksi halde 6 paketlik indirim 3 pakete uygulanıp yanlış, çok düşük bir toplam çıkıyordu
        const filledTotal = filled.reduce((sum, slot) => sum + slot.variant.price, 0);
        const total = filledTotal + missing * this.basePrice;
        const discount = this.discountFor(this.slots.length);
        const final = Math.max(total - discount, 0);
        this.els.total.textContent = this.slots.length ? this.formatter.format(final / 100) : '–';
        if (this.els.compare) {
          this.els.compare.hidden = !(discount > 0);
          this.els.compare.textContent = this.formatter.format(total / 100);
        }
        this.els.add.disabled = missing > 0;
        if (missing > 0) {
          this.els.status.textContent = this.strings.fillFirst.replace('[count]', missing);
        } else if (resetStatus) {
          this.els.status.textContent = '';
        }
        if (this.els.gift) {
          this.els.gift.hidden = this.giftVariant
            ? !this.qualifiesForGift(filled)
            : !(this.free > 0 || this.qualifiesForGift(this.slots));
        }
        this.updateBar(filled, final);
      }

      updateBar(filled, final) {
        if (!this.els.bar) return;
        this.els.barCount.textContent = this.strings.barCount
          .replace('[filled]', filled.length)
          .replace('[total]', this.slots.length);
        this.els.barTotal.textContent = filled.length ? this.formatter.format(final / 100) : '';
        const missing = this.slots.length - filled.length;
        this.els.barAdd.disabled = missing > 0;
        this.els.barAdd.textContent = missing > 0 ? this.strings.barMissing.replace('[count]', missing) : this.strings.barAdd;
        this.els.barThumbs.innerHTML = this.slots
          .map((slot) => {
            if (!slot) return '<span class="sg-pack__bar-thumb is-empty"></span>';
            const image = this.imageFor(this.products[slot.product], slot.color);
            return image
              ? `<span class="sg-pack__bar-thumb"><img src="${image}" alt="" width="64" height="64"></span>`
              : `<span class="sg-pack__bar-thumb" style="background: ${this.hexFor(slot.color) || 'currentColor'}"></span>`;
          })
          .join('');
      }

      // Hediye: eşik çift sayısına, hediye ürününün kendisi hariç paketlerle ulaşılmalı
      qualifiesForGift(slots) {
        if (!(this.giftThreshold > 0)) return false;
        const counted = this.giftProduct
          ? slots.filter((slot) => !slot || this.products[slot.product].id !== this.giftProduct)
          : slots;
        return counted.length * this.pairsPerUnit >= this.giftThreshold;
      }

      discountFor(units) {
        if (this.prices.length) {
          // Toplam fiyat tablosu: en büyük uygun eşik t için indirim = taban × t − toplam(t)
          const tier = this.prices.find(([threshold]) => units >= threshold);
          return tier ? Math.max(this.basePrice * tier[0] - Math.round(tier[1] * 100), 0) : 0;
        }
        const match = this.discounts.find(([threshold]) => units >= threshold);
        return match ? Math.round(match[1] * 100) : 0;
      }

      async addToCart() {
        // Hediye sıraları sepette ayrı satır, 'Paket: Hediye' notuyla (indirim toplam paket sayısından gelir)
        const counts = new Map();
        this.slots.forEach((slot, index) => {
          if (!slot) return;
          const key = `${slot.variant.id}:${this.isGiftSlot(index) ? 'gift' : ''}`;
          counts.set(key, (counts.get(key) || 0) + 1);
        });
        if (!counts.size) return;
        const items = [...counts].map(([key, quantity]) => {
          const [id, gift] = key.split(':');
          const item = { id: parseInt(id, 10), quantity };
          if (gift) item.properties = { Paket: `${this.strings.giftTag} 🎁` };
          return item;
        });
        if (this.giftVariant && this.qualifiesForGift(this.slots)) items.push({ id: this.giftVariant, quantity: 1 });
        const drawer = document.querySelector('cart-drawer');

        this.els.add.disabled = true;
        this.els.add.classList.add('loading');
        if (this.els.barAdd) {
          this.els.barAdd.disabled = true;
          this.els.barAdd.classList.add('loading');
        }
        this.els.status.textContent = '';
        try {
          const response = await fetch(`${window.routes ? window.routes.cart_add_url : '/cart/add'}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items,
              sections: drawer ? 'cart-drawer,cart-icon-bubble' : undefined,
              sections_url: window.location.pathname,
            }),
          });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || result.message || 'cart error');

          this.els.status.textContent = this.strings.added;
          this.toast(this.strings.added);
          this.classList.add('is-added');
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sg-pack-builder', cartData: result });
          }
          if (drawer && typeof drawer.renderContents === 'function' && result.sections) {
            try {
              drawer.classList.remove('is-empty');
              drawer.renderContents({ id: items[0].id, sections: result.sections });
              return;
            } catch (error) {
              console.error(error);
            }
          }
          window.location.href = window.routes ? window.routes.cart_url : '/cart';
        } catch (error) {
          console.error(error);
          this.els.status.textContent = error.message && error.message !== 'cart error' ? error.message : this.strings.error;
        } finally {
          this.els.add.classList.remove('loading');
        if (this.els.barAdd) this.els.barAdd.classList.remove('loading');
          this.updateSummary(false);
          window.setTimeout(() => this.classList.remove('is-added'), 1200);
        }
      }
    }
  );
}
